'use client';
import { cx } from '@linaria/core';
import React, { useCallback } from 'react';

import { SubHeadline } from '~components/Typography';
import { routes } from '~constants/routes';
import { getDiscordSsoUrl } from '~features/discord/utils/getDiscordSsoUrl';
import { useTranslations } from '~i18n/hooks';
import DiscordIcon from '~public/assets/icons/discord-circle.svg';
import { DropdownElement, DropdownSeparator } from '~shared/ui/atoms/Dropdown';

import { ConnectDiscordDropdownElement, TileElement } from './styles';

export const ConnectDiscordItem = () => {
	const t = useTranslations('ProfileMenu');

	const handleClick = useCallback(
		() =>
			(window.location.href = getDiscordSsoUrl(routes.auth.discord.connect)),
		[]
	);

	return (
		<>
			<DropdownSeparator />
			<DropdownElement
				data-name="settings-item"
				secondaryIcon={<DiscordIcon />}
				className={cx(ConnectDiscordDropdownElement, TileElement)}
				onClick={handleClick}
				hint={t('connectDiscordSubtitle')}
			>
				<SubHeadline size="S" color="grey-95-solid" align="left">
					{t('connectDiscordTitle')}
				</SubHeadline>
			</DropdownElement>
		</>
	);
};
